import { Skeleton } from "antd";
import React, { useEffect, useState } from "react";
import styled from "styled-components";

type LoaderWithTimerProps = {
    isLoading: boolean;
    minLoadingTime?: number;
    skeletonStyle?: string;
}

const StyledSkeleton = styled.div`
    margin-top: 8px;
    display: flex;
    gap: 16px;
`

const CandidateSkeleton = <StyledSkeleton style={{padding: '24px'}}><Skeleton.Image active/><Skeleton active title paragraph/></StyledSkeleton>;
const VacancySkeleton = <StyledSkeleton style={{padding: '24px'}}><Skeleton active/></StyledSkeleton>;
const RepliesSkeleton = <StyledSkeleton><Skeleton active paragraph={{rows: 2}}/></StyledSkeleton>
const BigImage = <Skeleton.Image active style={{width: '368px', height: '245px'}}/>;
const MainInformation = <StyledSkeleton><Skeleton active paragraph={{rows: 5}}/></StyledSkeleton>;
const tableSkeleton = <Skeleton active title={false} paragraph={{rows: 10}}/>;
const CandidatePageSkeleton = 
    <StyledSkeleton style={{flexDirection: 'column', padding: '24px', width: '70%', marginLeft: '50px'}}>
        <StyledSkeleton><Skeleton.Image active/><Skeleton active title paragraph/></StyledSkeleton>
        <Skeleton active paragraph={{rows: 2}}/>
        <Skeleton active paragraph={{rows: 2}}/>
        <Skeleton active paragraph={{rows: 2}}/>
    </StyledSkeleton>;

export const LoaderWithTimer = ({ isLoading,  minLoadingTime = 800, skeletonStyle} : LoaderWithTimerProps) => {
    const [showLoader, setShowLoader] = useState(false);
    const [loadingStartTime, setLoadingStartTime] = useState<number | null>(null);

    let skeletonElement;

    switch (skeletonStyle) {
        case "candidate":
            skeletonElement = CandidateSkeleton;
            break;
        case "vacancy":
            skeletonElement = VacancySkeleton;
            break;
        case "bigImage":
            skeletonElement = BigImage;
            break;
        case "replies":
            skeletonElement = RepliesSkeleton;
            break;
        case "mainInformation":
            skeletonElement = MainInformation;
            break;
        case "table":
            skeletonElement = tableSkeleton;
            break;
        case "candidatePage":
            skeletonElement = CandidatePageSkeleton;
            break;
        default:
            skeletonElement = CandidateSkeleton;
    }

    useEffect(() => {
        let timer: NodeJS.Timeout;
        
        if (isLoading) {
            setLoadingStartTime(Date.now());

            timer = setTimeout(() => {
                setShowLoader(true);
            }, minLoadingTime);
        } else {
            const loadingTime = loadingStartTime ? Date.now() - loadingStartTime : 0;
            const remainingTime = minLoadingTime - loadingTime;

            if (remainingTime > 0) {
                timer = setTimeout(() => {
                    setShowLoader(false);
                }, remainingTime);
            } else {
                setShowLoader(false);
            }
        }
        return () => clearTimeout(timer);

    }, [isLoading]);

    return (
        <>
            {showLoader && skeletonElement}
        </>
    )
}